// @NOTE: These media queries should be merged into `src/themes/arcadiaLate2021/declaratives.ts`
//        when the Grid component is more widely adopted.
// Trying to read breakpoints alphabetically vs
// in actual order... is confusing.
const breakpoints = {
    phone: 375,
    tabletPortrait: 600,
    tabletLandscape: 900,
    desktop: 1280,
    largeScreen: 1600,
};
const media = Object.keys(breakpoints).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [`${key}Down`]: `max-width: ${breakpoints[key] - 1}px`, [`${key}Up`]: `min-width: ${breakpoints[key]}px` })), {
    phoneDown: '',
    phoneUp: '',
    tabletPortraitDown: '',
    tabletPortraitUp: '',
    tabletLandscapeDown: '',
    tabletLandscapeUp: '',
    desktopDown: '',
    desktopUp: '',
    largeScreenDown: '',
    largeScreenUp: '',
});
const theme = {
    breakpoints,
    media,
};

export { theme as default };
